import { render, staticRenderFns } from "./damageItem.pug?vue&type=template&id=ea284356&lang=pug&external"
import script from "./damageItem.js?vue&type=script&lang=js&external"
export * from "./damageItem.js?vue&type=script&lang=js&external"
import style0 from "./damageItem.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Multiasistencia\\selfcare\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ea284356')) {
      api.createRecord('ea284356', component.options)
    } else {
      api.reload('ea284356', component.options)
    }
    module.hot.accept("./damageItem.pug?vue&type=template&id=ea284356&lang=pug&external", function () {
      api.rerender('ea284356', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/Damage/views/multidamageList/components/damageItem/index.vue"
export default component.exports